import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { UserPreferencesActions } from './user-preferences.actions';
import { UserPreferencesApiService } from '@app/core/api/user-preferences';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class UserPreferencesEffects {
  private readonly actions$ = inject(Actions);
  private readonly preferencesApiService = inject(UserPreferencesApiService);
  private readonly logger = inject(LoggerService).scope('UserPreferencesEffects');

  loadPreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferencesActions.loadPreferences),
      switchMap(() =>
        this.preferencesApiService.getPreferences().pipe(
          map(preferences => UserPreferencesActions.loadPreferencesSuccess({ preferences })),
          catchError(error => {
            this.logger.error('Load preferences failed:', error);
            return of(UserPreferencesActions.loadPreferencesFailure({ error: error.message }));
          })
        )
      )
    )
  );

  updatePreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferencesActions.updatePreferences),
      switchMap(({ data }) =>
        this.preferencesApiService.updatePreferences(data).pipe(
          map(preferences => UserPreferencesActions.updatePreferencesSuccess({ preferences })),
          catchError(error => {
            this.logger.error('Update preferences failed:', error);
            return of(UserPreferencesActions.updatePreferencesFailure({ error: error.message }));
          })
        )
      )
    )
  );

  updateOnboardingState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferencesActions.updateOnboardingState),
      switchMap(({ data }) =>
        this.preferencesApiService.updateOnboardingState(data).pipe(
          map(preferences => UserPreferencesActions.updateOnboardingStateSuccess({ preferences })),
          catchError(error => {
            this.logger.error('Update onboarding state failed:', error);
            return of(UserPreferencesActions.updateOnboardingStateFailure({ error: error.message }));
          })
        )
      )
    )
  );

  updateUiPreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferencesActions.updateUiPreferences),
      switchMap(({ data }) =>
        this.preferencesApiService.updateUiPreferences(data).pipe(
          map(preferences => UserPreferencesActions.updateUiPreferencesSuccess({ preferences })),
          catchError(error => {
            this.logger.error('Update UI preferences failed:', error);
            return of(UserPreferencesActions.updateUiPreferencesFailure({ error: error.message }));
          })
        )
      )
    )
  );
}
